import { render, staticRenderFns } from "./EventLabels.vue?vue&type=template&id=88f5e5ec&scoped=true&"
import script from "./EventLabels.vue?vue&type=script&lang=js&"
export * from "./EventLabels.vue?vue&type=script&lang=js&"
import style0 from "./EventLabels.vue?vue&type=style&index=0&id=88f5e5ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f5e5ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VChipGroup,VSheet,VTooltip})
